import { Avatar, Button, Group, Stack } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import UserAvatar from 'src/Components/NavBar/UserAvatar';
import useVoteProject from 'src/Hooks/Mutations/useVoteProject';
import { ProjectDto, VoteProjectDtoVoteEnum } from 'src/Services/API/generated/api';

import styles from './ProjectVoting.module.scss';

interface Props {
  project: ProjectDto;
}

export const ProjectVoting = ({ project }: Props) => {
  const { t } = useTranslation();
  const { mutate: voteProject, isLoading } = useVoteProject(project.assetId);

  const yesVotes = useMemo(
    () => project.votes?.filter(v => v.vote === VoteProjectDtoVoteEnum.Yes) || [],
    [project.votes]
  );

  const noVotes = useMemo(
    () => project.votes?.filter(v => v.vote === VoteProjectDtoVoteEnum.No) || [],
    [project.votes]
  );

  const handleVote = (e: React.MouseEvent, vote: VoteProjectDtoVoteEnum) => {
    e.preventDefault();
    e.stopPropagation();
    voteProject({ projectId: project.id, vote });
  };

  return (
    <Group grow gap="md" className={styles.container}>
      <Stack gap="xs" align="center">
        <div className={styles.voters}>
          <Avatar.Group spacing="sm">
            {yesVotes.map(vote => (
              <UserAvatar key={vote.id} user={vote.user} size="sm" />
            ))}
          </Avatar.Group>
        </div>
        <Button
          variant="light"
          color="green"
          fullWidth
          onClick={e => handleVote(e, VoteProjectDtoVoteEnum.Yes)}
          loading={isLoading}
        >
          {t('common.yes', 'Oui')}
        </Button>
      </Stack>

      <Stack gap="xs" align="center">
        <div className={styles.voters}>
          <Avatar.Group spacing="sm">
            {noVotes.map(vote => (
              <UserAvatar key={vote.id} user={vote.user} size="sm" />
            ))}
          </Avatar.Group>
        </div>
        <Button
          variant="light"
          color="red"
          fullWidth
          onClick={e => handleVote(e, VoteProjectDtoVoteEnum.No)}
          loading={isLoading}
        >
          {t('common.no', 'Non')}
        </Button>
      </Stack>
    </Group>
  );
};
